//-- Copyright (c) 2021 TMT Insights Group, LLC
import { TaskConfig } from '@/__configs/config_types';

const taskConfig: TaskConfig = {
  // used to display custom fields in the task drawer
  // will appear between the "Action" and "Notes" fields

  // the keys will be nested by double underscores
  // job__title__program_id = job.title.program_id

  // to display only on a specific task type, pass `forTypes`: ['edit_task']
  // if blank, will display on all task types

  // customFields: {}
};

export default taskConfig;
